import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Pagination from '../Pagination';
import PostStyle2 from '../Post/PostStyle2';
import Div from '../Div';
import Sidebar from '../Sidebar.jsx';
import Spacing from '../Spacing';
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import BASE_URL from '../../utils/api.js';

export default function ProjectPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const projectsPerPage = 2;
  const [searchTerm, setSearchTerm] = useState('');

  pageTitle('Projects');

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/projects/`);
        setProjects(response.data);
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);
  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  //const indexOfLastProject = currentPage * projectsPerPage;
  //const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const filteredProjects = projects.filter(project =>
    project.projectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    project.projectDescriptions.some(desc =>
      desc.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
  const totalPages = Math.ceil(filteredProjects.length / projectsPerPage);

  //const totalPages = Math.ceil(projects.length / projectsPerPage);


  return (
    <>
      <PageHeading
        title="Our Projects"
        bgSrc="/images/blog_hero_bg.jpeg"
        pageLinkText="Projects"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              currentProjects.map((item, index) => (
                <Div key={item._id}>
                  <PostStyle2
                    thumb={item.projectImages?.[0] || '/images/default.jpg'}
                    title={item.projectName}
                    subtitle={item.projectDescriptions} // pass the full array
                    date={new Date(item.createdAt).toLocaleDateString()}
                    category="Project"
                    categoryHref="/projects"
                  />
                  {projects.length > index + 1 && <Spacing lg="95" md="60" />}
                </Div>
              ))
            )}
            <Spacing lg="60" md="40" />
            <ul className="cs-pagination_box cs-center cs-white_color cs-mp0 cs-semi_bold">
              {[...Array(totalPages)].map((_, i) => (
                <li key={i}>
                  <button
                    className={`cs-pagination_item cs-center ${currentPage === i + 1 ? 'active' : ''}`}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
              {currentPage < totalPages && (
                <li>
                  <button
                    className="cs-pagination_item cs-center"
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    <Icon icon="akar-icons:chevron-right" />
                  </button>
                </li>
              )}
            </ul>
          </Div>
          <Div className="col-xl-3 col-lg-4 offset-xl-1">
            <Spacing lg="40" md="80" />
            <h4 className="cs-sidebar_widget_title">Search..</h4>
                <form className="cs-sidebar_search">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                  <button className="cs-sidebar_search_btn">
                    <Icon icon="material-symbols:search-rounded" />                   
                  </button>
                </form>
                <Spacing lg="40" md="40" />
                <h4 className="cs-sidebar_widget_title">All Projects</h4>
                <ul className='cs-side_menu_widget'>
                  {projects.map((project, index) => (
                    <li key={index}>
                      <Icon icon="material-symbols:keyboard-double-arrow-right-rounded" />
                      <span>{project.projectName}</span>
                    </li>
                  ))}
                </ul>           
            
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Cta
          title="Together, We Can Build Something <br/> <i> Great</i>?"
          btnText="Contact Our Experts "
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
    </>
  );
}
